import React from 'react';
import FadeIn from './FadeIn';

const flow = ["Getting Ready", "The Ceremony", "Cocktail Hour", "Dinner Service", "Dancing", "Memorable Sendoff"];

const WeddingFlow = () => (
  <section className="py-20 md:py-24 bg-brand-champagne/30 px-6 border-y border-brand-stone/30">
    <div className="max-w-5xl mx-auto text-center">
      <FadeIn>
        <h2 className="font-serif text-3xl text-brand-charcoal mb-12">The Rhythm of Your Celebration</h2>
      </FadeIn>
      <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6">
        {flow.map((step, idx) => (
          <React.Fragment key={idx}>
            <FadeIn delay={idx * 0.08}>
              <div className="bg-white px-5 py-3 rounded-full shadow-sm border border-brand-stone/20 text-sm font-sans tracking-wide text-brand-charcoal/80">
                {step}
              </div>
            </FadeIn>
            {idx < flow.length - 1 && (
              <span className="hidden md:block text-brand-olive/50">⟶</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
);

export default WeddingFlow;